module.exports = __webpack_public_path__ + "static/video-cf3ea667b83770fcbe25d7fd23a403d5.png";